// This icon file is generated automatically.
var PTagsOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M6.55 11.35l5.9-5.91a.12.12 0 00.05-.1L12.1.63a.25.25 0 00-.23-.23L7.16 0c-.04 0-.07.01-.1.04l-5.9 5.91a.13.13 0 000 .18l5.21 5.22c.05.05.13.05.18 0zm.98-10.18l3.5.3.3 3.5-4.87 4.87-3.8-3.8 4.87-4.87zm.94 2.9a.75.75 0 101.06-1.06.75.75 0 00-1.06 1.07zm4.43 3.36l-.62-.61a.13.13 0 00-.17 0l-5.66 5.64-3.71-3.7a.13.13 0 00-.18 0l-.62.62a.13.13 0 000 .17l3.8 3.8.62.61c.05.05.13.05.18 0l6.36-6.35a.13.13 0 000-.18z", "fill-rule": "nonzero" } }] }, "name": "p-tags", "theme": "outlined" };
export default PTagsOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PTagsOutlined.js
// module id = 3683
// module chunks = 0